import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	requiredFieldsSummary: {
		id: 'townsquare.teams-settings.custom-field-form.required-fields-summary',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Header text indicating required fields in the custom field form',
	},
	nameLabel: {
		id: 'townsquare.teams-settings.custom-field-form.name-label',
		defaultMessage: 'Name',
		description: 'Label shown above the name input field in the custom field creation or edit form.',
	},
	nameHelperMessage: {
		id: 'townsquare.teams-settings.custom-field-form.name-helper-message',
		defaultMessage: 'Max length of 30 characters',
		description:
			'Helper text shown beneath the name input in the custom field form, indicating the maximum allowed character count.',
	},
	fieldTypeLabel: {
		id: 'townsquare.teams-settings.custom-field-form.field-type-label',
		defaultMessage: 'Field type',
		description: 'Label shown above the field type dropdown in the custom field creation or edit form.',
	},
	fieldTypeTrigger: {
		id: 'townsquare.teams-settings.custom-field-form.field-type-trigger',
		defaultMessage: 'Select a field type',
		description: 'Trigger text for the custom field type dropdown',
	},
	fieldTypeText: {
		id: 'townsquare.teams-settings.custom-field-form.field-type-text',
		defaultMessage: 'Text',
		description: 'Drop-down item label for the Text option in the field type selector of the custom field form.',
	},
	fieldTypeDropdown: {
		id: 'townsquare.teams-settings.custom-field-form.field-type-select',
		defaultMessage: 'Select',
		description: 'Drop-down item label for the Select option in the field type selector of the custom field form.',
	},
	fieldTypePeople: {
		id: 'townsquare.teams-settings.custom-field-form.field-type-people',
		defaultMessage: 'People',
		description: 'Drop-down item label for the People option in the field type selector of the custom field form.',
	},
	fieldTypeNumber: {
		id: 'townsquare.teams-settings.custom-field-form.field-type-number',
		defaultMessage: 'Number',
		description: 'Drop-down item label for the Number option in the field type selector of the custom field form.',
	},
	fieldTypeHelperMessage: {
		id: 'townsquare.teams-settings.custom-field-form.field-type-helper-message',
		defaultMessage: "You can't change the type after creating a field.",
		description:
			'Helper text shown beneath the field type selector in the custom field form, warning that the type cannot be changed after creation.',
	},
	formatLabel: {
		id: 'townsquare.teams-settings.custom-field-form.format-label',
		defaultMessage: 'Format',
		description: 'Label for the people field format dropdown',
	},
	formatPlaceholder: {
		id: 'townsquare.teams-settings.custom-field-form.format-placeholder',
		defaultMessage: 'Select a format',
		description: 'Placeholder for the people format dropdown',
	},
	formatIndividuals: {
		id: 'townsquare.teams-settings.custom-field-form.format-individuals',
		defaultMessage: 'Individuals',
		description: 'Individuals format option for people field',
	},
	formatTeam: {
		id: 'townsquare.teams-settings.custom-field-form.format-team',
		defaultMessage: 'Team',
		description: 'Drop-down item label for the Team format option when configuring a people-type custom field.',
	},
	formatNumber: {
		id: 'townsquare.teams-settings.custom-field-form.format-number',
		defaultMessage: '# Number',
		description: 'Drop-down item label for the plain number format option when configuring a number-type custom field.',
	},
	formatPercentage: {
		id: 'townsquare.teams-settings.custom-field-form.format-percentage',
		defaultMessage: '% Percentage',
		description: 'Percentage format option for number field',
	},
	formatCurrency: {
		id: 'townsquare.teams-settings.custom-field-form.format-currency',
		defaultMessage: '$ Currency',
		description: 'Drop-down item label for the currency format option when configuring a number-type custom field.',
	},
	currencyLabel: {
		id: 'townsquare.teams-settings.custom-field-form.currency-label',
		defaultMessage: 'Currency',
		description: 'Label for the currency dropdown when format is Currency',
	},
	descriptionLabel: {
		id: 'townsquare.teams-settings.custom-field-form.description-label',
		defaultMessage: 'Description',
		description: 'Label for the custom field description field',
	},
	descriptionHelperMessage: {
		id: 'townsquare.teams-settings.custom-field-form.description-helper-message',
		defaultMessage: 'Users see this info when they hover over the field.',
		description:
			'Helper text shown beneath the description input in the custom field form, explaining that users see it on hover.',
	},
	nameTooLongError: {
		id: 'townsquare.teams-settings.custom-field-form.name-too-long-error',
		defaultMessage: 'Must be 30 characters or less.',
		description: 'Error message when field name exceeds character limit',
	},
	descriptionTooLongError: {
		id: 'townsquare.teams-settings.custom-field-form.description-too-long-error',
		defaultMessage: 'Must be 60 characters or less.',
		description: 'Error message when description exceeds character limit',
	},
	fieldCardinalityLabel: {
		id: 'townsquare.teams-settings.custom-field-form.field-cardinality-label',
		defaultMessage: 'Let users select multiple options',
		description: 'Label for the custom field cardinality checkbox',
	},
	removeOptionTooltip: {
		id: 'townsquare.teams-settings.custom-field-form.remove-option-tooltip',
		defaultMessage: 'Remove option',
		description: 'Tooltip shown on the button that removes a select option from the custom field options list.',
	},
	addOption: {
		id: 'townsquare.teams-settings.custom-field-form.add-option',
		defaultMessage: 'Add option',
		description: 'Button label for adding a new option to the select field options list in the custom field form.',
	},
	optionValueRequired: {
		id: 'townsquare.teams-settings.custom-field-form.option-name-required',
		defaultMessage: 'A name is required for this option.',
		description:
			'Validation error message shown beneath an option input when the user submits the custom field form without entering a name for that option.',
	},
	optionAlreadyExists: {
		id: 'townsquare.teams-settings.custom-field-form.option-already-exists',
		defaultMessage: 'This option already exists. Give it another name.',
		description: 'Error message when option value is duplicated',
	},
	maxOptionsReached: {
		id: 'townsquare.teams-settings.custom-field-form.max-options-reached',
		defaultMessage: 'You can select up to 50 items. Remove one to choose another.',
		description: 'Error message when maximum number of options is reached',
	},
	fieldOptionsLabel: {
		id: 'townsquare.teams-settings.custom-field-form.field-options-label',
		defaultMessage: 'Options',
		description:
			'Label shown above the list of selectable options in the custom field form when the field type is set to Select.',
	},
	optionValueAriaLabel: {
		id: 'townsquare.teams-settings.custom-field-form.option-value-aria-label',
		defaultMessage: 'Option value',
		description: 'Accessible label for option value input field',
	},
	optionValueTooLong: {
		id: 'townsquare.teams-settings.custom-field-form.option-value-too-long',
		defaultMessage: 'Must be 50 characters or less.',
		description: 'Error message when option value exceeds character limit',
	},
});
